import { useAtomValueRawSync } from 'jotai';

import { portalMonitor } from '@/api/portalMonitor';
import { portalUnavailableAtom } from '@/state/api/portalMonitorAtoms';

interface PortalStatus {
    /** True while the portal monitor cannot reach the cloud. */
    isUnavailable: boolean;
    /** Probes at once, without a wait for the next interval. */
    tryNow: () => void;
}

function tryNow(): void {
    portalMonitor.probeNow();
}

export function usePortalUnavailable(): PortalStatus {
    const isUnavailable = useAtomValueRawSync(portalUnavailableAtom);
    return {
        isUnavailable,
        tryNow,
    };
}
